import * as React from "react";
const VolumeSlashSvgIcon = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.218182" y="0.218182" width="31.5636" height="31.5636" rx="15.7818" fill="white"/>
<rect x="0.218182" y="0.218182" width="31.5636" height="31.5636" rx="15.7818" stroke="#676C6F" stroke-width="0.436364"/>
<path d="M9.33337 14.773V17.4396C9.33337 18.773 10 19.4396 11.3334 19.4396H12.2867C12.5334 19.4396 12.78 19.513 12.9934 19.6396L14.94 20.8596C16.62 21.913 18 21.1463 18 19.1663V13.0463C18 11.0596 16.62 10.2996 14.94 11.353L12.9934 12.573C12.78 12.6996 12.5334 12.773 12.2867 12.773H11.3334C10 12.773 9.33337 13.4396 9.33337 14.773Z" stroke="#676C6F"/>
<path d="M22.6667 17.413L20.0267 14.773" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" stroke="#676C6F"/>
<path d="M22.64 14.7996L20 17.4396" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" stroke="#676C6F"/>
</svg>

);
export default VolumeSlashSvgIcon;

